import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DocumentoEntradaService } from '../../services/documento-entrada.service';
import { DocumentoEntrada } from '../../model/documento-entrada';
import { DocumentoDetalleEntradaService } from '../../services/documento-detalle-entrada.service';
import { DocumentoDetalleEntrada } from '../../model/documento-detalle-entrada';

@Component({
  selector: 'app-documento-entrada-detalle-list',
  templateUrl: './documento-entrada-detalle-list.component.html',
  styleUrls: ['./documento-entrada-detalle-list.component.css']
})
export class DocumentoEntradaDetalleListComponent implements OnInit {

  public modoEdicion: boolean = false;

  @Input() documento: DocumentoEntrada;

  public detalles: DocumentoDetalleEntrada[];
  public detalle: DocumentoDetalleEntrada;

  public detalleSeleccionado: DocumentoDetalleEntrada;
  public query: any;
  constructor(
    private _documentoDetalleEntradaService: DocumentoDetalleEntradaService,
  ) { }

  ngOnInit() {
     if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.detalleSeleccionado = new DocumentoDetalleEntrada();
    this.cargarDetalle();

  }

  cargarDetalle() {
    if (this.documento.codigoConsorcio && this.documento.codigoDocumento) {
      this._documentoDetalleEntradaService.getDetalle(this.documento)
        .subscribe(
        data => {
          this.detalles = data;
        },
        err => {
          console.log(err._body);
        });
    }

  }

  agregarRegistro() {
    if (this.documento === null) {
      return;
    }
    this.detalleSeleccionado = new DocumentoDetalleEntrada();
    this.modoEdicion = true;
  }


  regresar() {
    this.modoEdicion = false;
    this.cargarDetalle();
  }

  editarRegistro(detalle: DocumentoDetalleEntrada) {
    this.detalleSeleccionado = detalle;
    this.modoEdicion = true;
  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/documento-entrada-detalle-list/documento-entrada-detalle-list.component.ts